import { useMutation } from 'react-query'
import { deleteOnlyApiUser } from 'services/cm-api/delete-only-api-user'

export function useDeleteOnlyApiUser({ onSuccess, onError }) {
  return useMutation(deleteOnlyApiUser, {
    onSuccess,
    onError,
  })
}
